export default function Properties() {
  return (
    <section id="properties" className="py-24 bg-stone-50">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Top Text Area */}
        <div className="mb-16">
          <p className="text-sm font-light text-gray-600 tracking-widest mb-6">FEATURED PROPERTIES</p>
          
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
            <div className="lg:w-2/3">
              <h2 className="text-5xl lg:text-6xl font-black text-gray-900 leading-tight mb-6">
                厳選された上質な住まいを、<br />
                あなたへ。
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed max-w-2xl">
                お客様のライフスタイルに合わせた最適な物件を、経験豊富なエージェントがご提案いたします
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Image Area */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          {/* Left Image */}
          <div className="lg:col-span-2">
            <div className="rounded-3xl overflow-hidden aspect-[4/5] w-full h-full">
              <img
                src="https://readdy.ai/api/search-image?query=Luxury%20modern%20residential%20building%20exterior%20with%20contemporary%20architecture%20and%20clean%20lines%2C%20high-end%20property%20facade%20with%20sophisticated%20design%20and%20elegant%20materials%2C%20professional%20real%20estate%20photography%20with%20natural%20lighting%20and%20neutral%20color%20palette%2C%20architectural%20showcase%20with%20refined%20aesthetic%20and%20studio%20quality%20composition&width=800&height=1000&seq=property-ext-001&orientation=portrait"
                alt="物件外観"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right Image */}
          <div className="lg:col-span-3">
            <div className="rounded-3xl overflow-hidden aspect-[16/10] w-full h-full">
              <img
                src="https://readdy.ai/api/search-image?query=Luxurious%20modern%20interior%20living%20space%20with%20minimalist%20design%20and%20sophisticated%20furnishings%2C%20contemporary%20residential%20interior%20with%20clean%20lines%20and%20elegant%20decor%2C%20high-end%20property%20interior%20photography%20with%20natural%20lighting%20and%20neutral%20tones%2C%20spacious%20living%20room%20with%20refined%20aesthetic%20and%20studio%20quality%20composition&width=1600&height=1000&seq=property-int-001&orientation=landscape"
                alt="物件インテリア"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Property Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16" data-product-shop>
          {/* Property 1 */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
            <div className="aspect-[4/3] w-full h-64">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20luxury%20apartment%20exterior%20with%20contemporary%20design%20and%20clean%20architecture%2C%20high-end%20residential%20building%20facade%20with%20sophisticated%20materials%20and%20elegant%20composition%2C%20professional%20real%20estate%20photography%20with%20natural%20lighting%20and%20neutral%20color%20palette%2C%20premium%20property%20showcase%20with%20refined%20aesthetic%20quality&width=800&height=600&seq=prop-card-001&orientation=landscape"
                alt="高級マンション"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6">
              <div className="flex items-center gap-2 mb-3">
                <span className="px-3 py-1 bg-gray-900 text-white text-xs font-medium rounded-full whitespace-nowrap">新築</span>
                <span className="px-3 py-1 bg-stone-100 text-gray-700 text-xs font-medium rounded-full whitespace-nowrap">駅近</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">プレミアムタワー港区</h3>
              <p className="text-gray-600 text-sm mb-4">港区六本木 / 3LDK / 85㎡</p>
              <div className="flex items-end justify-between">
                <div>
                  <p className="text-3xl font-black text-gray-900">¥128M</p>
                  <p className="text-xs text-gray-500">管理費・修繕積立金別</p>
                </div>
                <button className="px-4 py-2 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap">
                  詳細を見る
                </button>
              </div>
            </div>
          </div>

          {/* Property 2 */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
            <div className="aspect-[4/3] w-full h-64">
              <img
                src="https://readdy.ai/api/search-image?query=Contemporary%20residential%20house%20exterior%20with%20modern%20architecture%20and%20elegant%20design%2C%20stylish%20single-family%20home%20with%20clean%20lines%20and%20sophisticated%20materials%2C%20professional%20real%20estate%20photography%20with%20natural%20lighting%20and%20neutral%20tones%2C%20premium%20property%20exterior%20with%20refined%20aesthetic%20and%20studio%20quality&width=800&height=600&seq=prop-card-002&orientation=landscape"
                alt="デザイナーズ戸建"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6">
              <div className="flex items-center gap-2 mb-3">
                <span className="px-3 py-1 bg-stone-100 text-gray-700 text-xs font-medium rounded-full whitespace-nowrap">デザイナーズ</span>
                <span className="px-3 py-1 bg-stone-100 text-gray-700 text-xs font-medium rounded-full whitespace-nowrap">庭付き</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">モダンハウス世田谷</h3>
              <p className="text-gray-600 text-sm mb-4">世田谷区成城 / 4LDK / 120㎡</p>
              <div className="flex items-end justify-between">
                <div>
                  <p className="text-3xl font-black text-gray-900">¥95M</p>
                  <p className="text-xs text-gray-500">土地面積150㎡</p>
                </div>
                <button className="px-4 py-2 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap">
                  詳細を見る
                </button>
              </div>
            </div>
          </div>

          {/* Property 3 */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
            <div className="aspect-[4/3] w-full h-64">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20apartment%20building%20exterior%20with%20contemporary%20design%20and%20sophisticated%20architecture%2C%20modern%20residential%20complex%20with%20clean%20lines%20and%20premium%20materials%2C%20professional%20real%20estate%20photography%20with%20natural%20lighting%20and%20neutral%20color%20palette%2C%20high-end%20property%20showcase%20with%20refined%20aesthetic%20quality&width=800&height=600&seq=prop-card-003&orientation=landscape"
                alt="高級レジデンス"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6">
              <div className="flex items-center gap-2 mb-3">
                <span className="px-3 py-1 bg-gray-900 text-white text-xs font-medium rounded-full whitespace-nowrap">リノベ済</span>
                <span className="px-3 py-1 bg-stone-100 text-gray-700 text-xs font-medium rounded-full whitespace-nowrap">眺望良好</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">スカイレジデンス渋谷</h3>
              <p className="text-gray-600 text-sm mb-4">渋谷区恵比寿 / 2LDK / 70㎡</p>
              <div className="flex items-end justify-between">
                <div>
                  <p className="text-3xl font-black text-gray-900">¥82M</p>
                  <p className="text-xs text-gray-500">最上階角部屋</p>
                </div>
                <button className="px-4 py-2 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap">
                  詳細を見る
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
